{
  "internalPortal": {
    "pages": {
      "organizations": {
        "title": "Organizations",
        "new": "New organization",
        "subtitle": "Manage client organizations, locations & spend"
      }
    },
    "components": {
      "organizationsTable": {
        "columns": {
          "organizationName": "Organization name",
          "parentOrganization": "Parent organization",
          "status": "Status",
          "primaryContact": "Primary contact",
          "locations": "Locations",
          "inScopeSpend": "In scope spend",
          "savingsIdentified": "Savings identified",
          "savingsApproved": "Savings approved",
          "openAudits": "Open audits",
          "more": "More"
        },
        "noData": {
          "withFilters": {
            "title": "No organizations match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No organizations found",
            "description": "No organizations found, you can create them by clicking the button in the top right corner."
          }
        }
      },
      "organizationFilters": {
        "options": {
          "all": "All",
          "myManagedOrganizations": "My Managed Organizations",
          "active": "Active",
          "inactive": "Inactive",
          "withSubsidiary": "With subsidiary organizations"
        }
      },
      "tabs": {
        "overview": "Overview",
        "comments": "Comments",
        "billPay": "BillPay",
        "subsidiaryOrg": "Subsidiary org",
        "locations": "Locations",
        "users": "Users",
        "vendors": "Vendors",
        "vendorAccounts": "Vendor Accounts",
        "spendSavings": "Spend & Savings",
        "documents": "Documents",
        "invoices": "Invoices",
        "work": "Work",
        "sibContracts": "SIB Contracts",
        "audits": "Audits",
        "futureOpportunities": "Future opportunities",
        "billing": "Billing",
        "services": "Services",
        "vsr": "VSR"
      },
      "tabPlaceholder": {
        "title": "We're working on it",
        "description": "This view is not available yet"
      },
      "services": {
        "title": "Services",
        "subtitle": "List of currently active and former services that are included in this organization's invoice",
        "tabs": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "status": {
          "active": "Active",
          "former": "Inactive"
        },
        "billingFrequency": {
          "one_time": "One time",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "annually": "Annually"
        },
        "table": {
          "columns": {
            "service": "Service",
            "status": "Status",
            "priceOccurrence": "Price / Occurrence",
            "billingFrequency": "Billing Frequency",
            "activated": "Activated"
          },
          "priceOccurrence": {
            "till": "Till",
            "since": "Since"
          }
        },
        "priceHistory": {
          "open": "View price history",
          "priceChange": "Price change",
          "date": "Date",
          "note": "Note",
          "currentPrice": "Current price",
          "unavailable": "Price history is not available yet."
        },
        "upcomingBilling": {
          "title": "Upcoming Billing Occurrences",
          "unavailable": "Upcoming billing occurrences could not be loaded.",
          "columns": {
            "dueDate": "Due Date",
            "amount": "Amount",
            "status": "Status"
          },
          "status": {
            "owed": "Pending confirmation",
            "submitted": "Submitted",
            "billed": "Billed",
            "void": "Void"
          }
        },
        "deactivateDialog": {
          "title": "Deactivate service",
          "description": "Are you sure you want to deactivate {{name}} effective {{date}}? Pending obligations that have not been revealed will be withdrawn.",
          "blockingDescription": "{{name}} cannot be deactivated because {{count}} obligation(s) have already been submitted or billed.",
          "loading": "Checking deactivation impact..."
        },
        "noData": {
          "withFilters": {
            "title": "No services match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No services found",
            "description": "This organization has no services in this view yet"
          }
        }
      },
      "billPay": {
        "title": "BillPay",
        "agent": {
          "title": "Bill pay agent"
        },
        "sections": {
          "billPayFundingFrequency": "BillPay Funding Frequency",
          "fundingDetailsSubmissionMethod": "Funding Details Submission Method",
          "billingAddress": "Billing address",
          "mailingAddress": "Mailing address"
        },
        "editForm": {
          "title": "Edit BillPay details",
          "success": "BillPay details updated successfully",
          "error": "BillPay details update failed",
          "options": {
            "billPayFundingFrequency": {
              "monthly": "Monthly",
              "quarterly": "Quarterly"
            },
            "fundingDetailsSubmissionMethod": {
              "email": "Email",
              "sftp": "SFTP"
            }
          }
        }
      },
      "comments": {
        "title": "Comments ({{count}})",
        "description": "Free-text notes logged against this organization. Widen the view to include comments left on its audits, tasks, tickets, meetings and validation spend groups.",
        "actions": {
          "addNew": "Add comment"
        },
        "sources": {
          "label": "Show comments from",
          "organization": "Organization",
          "audits": "Audits",
          "tasks": "Tasks",
          "tickets": "Tickets",
          "meetings": "Meetings",
          "validation": "Validation"
        },
        "filters": {
          "search": "Search",
          "creator": "Created by",
          "created": "Created"
        },
        "tile": {
          "relatedTo": "Related to",
          "seeMore": "See more",
          "seeLess": "See less",
          "edited": "edited",
          "editedAt": "Edited {{date}}",
          "actionsDisabledTooltip": "You can only edit or delete comments you created yourself."
        },
        "form": {
          "title": "Add comment",
          "editTitle": "Edit comment",
          "fields": {
            "comment": "Comment"
          },
          "notifications": {
            "createSuccess": "Comment added successfully.",
            "createError": "Failed to add the comment.",
            "updateSuccess": "Comment updated successfully.",
            "updateError": "Failed to update the comment."
          }
        },
        "deleteDialog": {
          "title": "Delete comment",
          "description": "This comment will be permanently removed. This action cannot be undone."
        },
        "discardDialog": {
          "title": "Discard unsaved changes?",
          "description": "This comment has not been saved yet. Closing the form discards what you typed.",
          "keepEditing": "Keep editing",
          "confirm": "Discard"
        },
        "emptyState": {
          "title": "No comments yet",
          "description": "Add the first comment to keep notes about this organization in one place.",
          "filteredTitle": "No comments match your filters",
          "filteredDescription": "Try a different search, author or date range, or clear the filters to see all comments."
        },
        "notifications": {
          "deleteSuccess": "Comment deleted successfully.",
          "deleteError": "Failed to delete the comment."
        }
      }
    }
  },
  "views": {
    "organizationView": {
      "tooltip": {
        "addNewStep": "Only client result managers can add new action items",
        "addNewTeam": "Only client result managers can add new team",
        "vectorOrganizationNotSupported": "Ticket creation is unavailable for Vector organizations"
      },
      "actionItemList": {
        "label": "Action items",
        "categoryLabel": {
          "fileUpload": "File upload",
          "meeting": "Meeting",
          "other": "Other"
        }
      },
      "newEntityButton": "New",
      "buttonOption": {
        "task": "Team task",
        "actionItem": "Action item",
        "team": "Team",
        "email": "E-mail",
        "subAudit": "SubAudit",
        "actionItemFromTemplates": "Action item from templates",
        "ticket": "Ticket"
      },
      "members": "Members",
      "past": "Past",
      "memberList": {
        "assignedTasks": "{{taskCount}} assigned tasks",
        "you": "You"
      },
      "pinOrganization": {
        "pin": "Pin to dashboard",
        "unpin": "Remove from dashboard",
        "view": "View",
        "activeTasks_one": "{{count}} Active Task",
        "activeTasks_other": "{{count}} Active Tasks"
      },
      "subAudit": {
        "button": "SubAudits"
      }
    }
  },
  "components": {
    "organizationDetailsHeader": {
      "breadcrumb": {
        "organizationList": "Organization list"
      },
      "moreMenu": {
        "label": "More options"
      },
      "scheduleMeeting": "Schedule meeting",
      "parentOrg": "parent org:",
      "badges": {
        "subsidiaryOrg": "Subsidiary org",
        "onboarded": "Onboarded"
      },
      "metrics": {
        "inScopeSpend": "In-scope spend:",
        "savingsIdentified": "Savings identified:",
        "savingsApproved": "Savings approved:"
      },
      "mainPointOfContact": "Main point of contact",
      "fields": {
        "phone": "Phone",
        "website": "Website",
        "websiteLink": "Link",
        "dba": "DBA",
        "currentValidator": "Current Validator",
        "accountRecordType": "Account Record Type",
        "originatingDivision": "Originating Division",
        "sibAutorenewalApproved": "SIB Autorenewal Approved",
        "salesforceSalesId": "Salesforce Sales ID",
        "sf2AccountUrl": "Salesforce Account",
        "sf2AccountLink": "Link",
        "industry": "Industry",
        "subIndustry": "Sub-industry",
        "annualRevenue": "Annual Revenue",
        "numberOfEmployees": "Number of employees",
        "primarySalesRep": "Primary Sales Rep",
        "clientWhoSignedSibSa": "Client Who Signed SIB SA"
      }
    },
    "organizationDetails": {
      "error": {
        "title": "Failed to load organization"
      }
    },
    "noDataPlaceholder": {
      "title": "No client members are assigned to this organization",
      "description": "Share access to SpendBrain and add first member to get started"
    },
    "organizationList": {
      "title": "My Organizations",
      "noOrganizationFound": "No organizations found",
      "membersCount": "{{count}} members",
      "activeTasksCount": "{{count}} active tasks",
      "other": "Other",
      "placeholder": "Find organization",
      "recentlySelected": "Recently selected",
      "sortBy": {
        "options": {
          "all": "All",
          "activeTasks": "Active tasks",
          "membership": "Membership"
        }
      }
    },
    "organizationEmailForm": {
      "title": "New Email",
      "fields": {
        "recipients": {
          "label": "Send to",
          "placeholder": "Select contact"
        },
        "title": {
          "label": "Title",
          "placeholder": "Email title"
        },
        "message": {
          "label": "Message",
          "placeholder": "Message"
        },
        "cc": {
          "label": "Add to thread",
          "placeholder": "Select contact"
        },
        "createTask": {
          "label": "Create related task"
        }
      },
      "submit": "Send",
      "task": {
        "title": "Send email: {{emailSubject}}",
        "description": "Send email with body:\n{{emailBody}}"
      }
    }
  },
  "enums": {
    "OrganizationStatus": {
      "dormant": "Dormant",
      "mobilization": "Mobilization",
      "negotiation": "Negotiation",
      "post_negotiation": "Post-negotiation",
      "pre_negotiation": "Pre-negotiation",
      "prospect": "Prospect",
      "update_required": "Update required",
      "validation": "Validation"
    },
    "AuditStatus": {
      "open": "Open",
      "cancelled": "Cancelled",
      "pending": "Pending",
      "on_hold": "On hold",
      "completed": "Completed"
    },
    "AuditStage": {
      "mobilization": "Mobilization",
      "spend_estimated": "Spend estimated",
      "negotiations_vendor": "Negotiations – Vendor",
      "negotiations_client": "Negotiations – Client",
      "initial_validation": "Initial validation",
      "monitoring_savings": "Monitoring savings"
    },
    "SalesforceAuditSource": {
      "parent_audit": "Parent audit",
      "vendor_split": "Vendor split",
      "subaudit": "Subaudit"
    },
    "VendorAccountStatus": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "BillingInterval": {
      "weekly": "Weekly",
      "bi_weekly": "Bi-weekly",
      "monthly": "Monthly",
      "bi_monthly": "Bi-monthly",
      "quarterly": "Quarterly",
      "annually": "Annually"
    }
  }
}
